import type { IdentifyTrait, UserTaxonomy } from '../contracts';
import { removePropertiesWithNullishValues } from '../helpers';

export function mapTraitsToTaxonomy(traits?: IdentifyTrait): UserTaxonomy {
    if (!traits) return {};
    const {
        registered,
        registration_platform,
        signed_in_status,
        user_creation_date,
        user_id,
        user_uuid,
        about_me_status
    } = traits;
    return removePropertiesWithNullishValues({
        registered,
        registration_platform,
        signed_in_status,
        user_creation_date,
        user_id,
        user_uuid,
        about_me_status
    });
}
